import script from "./InstructionCleverBoxPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionCleverBoxPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionCleverBoxPage.vue?vue&type=style&index=0&id=47338968&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47338968"]])

export default __exports__